import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { ExamSquareIcon } from "./Icons";

export default function Header() {
    const { user, logout } = useAuth();
    const nav = useNavigate();

    const dashboardPath = user?.role === "admin"
        ? "/admin"
        : user?.role === "owner"
            ? "/owner"
            : "/my-bookings";

    return (
        <header className="sticky top-0 z-40 border-b border-border bg-white/80 backdrop-blur-xl">
            <div className="mx-auto max-w-7xl px-6 h-16 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-2 group" data-testid="brand-link">
                    <span className="h-8 w-8 bg-primary text-primary-foreground grid place-items-center rounded-sm">
                        <ExamSquareIcon className="h-4 w-4" />
                    </span>
                    <div className="leading-none">
                        <div className="font-heading text-lg font-bold tracking-tight">BookedSlot</div>
                        <div className="overline text-[9px] mt-0.5">Real Exam Environment</div>
                    </div>
                </Link>

                <nav className="hidden md:flex items-center gap-8 text-sm">
                    <Link to="/centers" className="hover:text-primary transition-colors duration-150" data-testid="nav-centers">Find Centers</Link>
                    <Link to="/how-it-works" className="hover:text-primary transition-colors duration-150" data-testid="nav-how">How it works</Link>
                    {user?.role === "owner" && (
                        <Link to="/owner" className="hover:text-primary transition-colors duration-150" data-testid="nav-owner">Owner</Link>
                    )}
                    {user?.role === "admin" && (
                        <Link to="/admin" className="hover:text-primary transition-colors duration-150" data-testid="nav-admin">Admin</Link>
                    )}
                </nav>

                <div className="flex items-center gap-3">
                    {user ? (
                        <>
                            <Link to={dashboardPath} className="text-sm hidden sm:block hover:text-primary" data-testid="nav-dashboard">
                                {user.name}
                            </Link>
                            <Button variant="outline" size="sm" onClick={() => { logout(); nav("/"); }} className="rounded-sm" data-testid="logout-btn">
                                Logout
                            </Button>
                        </>
                    ) : (
                        <>
                            <Link to="/login" className="text-sm hover:text-primary" data-testid="nav-login">Login</Link>
                            <Link to="/register" data-testid="nav-register">
                                <Button size="sm" className="rounded-sm bg-primary hover:bg-primary/90">Sign up</Button>
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </header>
    );
}
